import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigationStart, Router } from '@angular/router';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CheckoutService } from "src/app/shared/modules/checkout/checkout.service";
import { GeneralPopupComponent } from "src/app/shared/modules/general-popup/general-popup/general-popup.component";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import { CustomInfluenzaService } from "../custom-influenza.service";
import { ProductDetailsInfluenzaComponent } from "../product-details-influenza/product-details-influenza.component";
import { CustomAuthService } from '../../custom-auth-service.service';

@Component({
    selector: 'app-reservation-overview',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './reservation-overview.component.html',
    styleUrls: ['./reservation-overview.component.scss'],
    standalone: false
})
export class ReservationOverviewComponent implements OnInit {
  iseditReservation: boolean = false;
  isEdit: boolean = false;
  reservationDetails: any;
  reservationDetailsEntries: any = [];
  reservationDetailsProducts: any = [];
  estimatedTotal: any;
  deliveryDetails: any = {}; //not seem to be used
  activityList: any;
  totalUnits: number = 0;
  totalDoses: number = 0;
  editable: boolean = true;
  estimatedSavings: number = 0;
  paymentMethod: string;
  paymentCardDetails: string;
  isSticky: boolean = false;
  subTotal: number = 0;
  total: number = 0;
  fluOrderActivityDetailsSub: Subscription;

  constructor(
    private readonly cd: ChangeDetectorRef,
    private baseSiteService: BaseSiteService,
    private readonly user: UserAccountFacade,
    private readonly authService: CustomAuthService,
    private router: Router,
    private readonly modalService: NgbModal,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly checkoutService: CheckoutService,
    private readonly routingService: RoutingService,
    private readonly sharedService: SharedService
  ) { }

  baseSiteId: string;
  userDataSub: Subscription;
  userData: any = [];

  fluTimer = 29 * 60 * 1000;  //29min
  fluTimerJourneySub: Subscription;
  FluExtendSub: Subscription;
  navigationEndSub: Subscription;
  logoutSub: Subscription;
  viewExcelSub: Subscription;
  @Input() reservationNo: string = '';
  stsFlag: boolean = false; //default false
  @Output() tabSelectedEvent = new EventEmitter<any>();

  checkFluTimerCompletion() {
    this.fluTimerJourneySub = this.influenzaService.fluTimerCompletedSubject.subscribe((res) => {
      if (res) {

        this.showFluExtendPopup();
      }
    })
  }
  showFluExtendPopup() {
    const modalRef = this.modalService.open(GeneralPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `fluLockExtendModal ${this.baseSiteId}`
    });
    modalRef.componentInstance.popup_title = 'Influenza Session Expiry';
    modalRef.componentInstance.popup_content = 'Your Influenza session is about to expire.<br />Do you want to continue on Influenza page?';
    modalRef.componentInstance.continueCancelButtons = true;
    this.FluExtendSub = modalRef.componentInstance.extendOrCancelEvent.subscribe((res) => {

      if (res === 'extend') {
        this.extendLock();
        this.influenzaService.extendFluJourneyTimer(this.fluTimer);
      }
      else {

        this.routingService.goByUrl('influenza/dashboard?fromFlu=yes'); //lock will be released on checkNavigationAway
      }
    });
  }

  extendLock() {
    const params = {
      "requstType": 'EXTENDLOCK',    //EXTENDLOCK to EXTEND
      "orderNumber": this.reservationNo  //reservationNo sample - 1092000246
    }

    this.influenzaService.fluLockOrUnlock(this.userData?.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessageNo = res.messageNumber;

          if (lockStatus === 'S' && lockMessageNo === '003') {

          }
          else {

          }
        }
      }, errors => {

      })
  }

  releaseLock() {
    const params = {
      "requstType": 'UNLOCK',    //UNLOCK to unlock
      "orderNumber": this.reservationNo  //reservationNo sample - 1092000246
    }
    this.influenzaService.fluLockOrUnlock(this.userData?.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessage = res.message;
          const lockMessageNo = res.messageNumber;

          if (lockStatus === 'S' && lockMessageNo === '002') {
            this.influenzaService.endFluJourneyTimer();
          }



        }
      }, errors => {

      });
  }
  checkLogout() {
    this.logoutSub = this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.releaseLock(); //AccessDeniedError might come at this time
        this.influenzaService.endFluJourneyTimer();
        this.logoutSub?.unsubscribe();
      }
    });
  }

  print() {
    window.print();
  }

  checkNavigationAway() {
    this.navigationEndSub = this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const nextRoute = event.url; //next route URL

          if (nextRoute?.includes('fluCategoryPage')) { //Edit reservation page

          }
          else {
            this.releaseLock();
          }
        }
      });
  }

  redirectToSelectVaccine() {
    this.router.navigate(['/fluCategoryPage'], { queryParams: { 'editReservation': 'yes', 'orderNo': this.reservationNo } });
  }

  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.navigationEndSub?.unsubscribe();
    this.fluTimerJourneySub?.unsubscribe();
    this.FluExtendSub?.unsubscribe();
    this.logoutSub?.unsubscribe();
    this.viewExcelSub?.unsubscribe();
    this.fluOrderActivityDetailsSub?.unsubscribe();
  }














  checkForExcelDownload() {
    this.viewExcelSub = this.influenzaService.viewReservationXlsdownload.subscribe((res) => {
      if (res != null && res === 'reservationOverview') {
        this.exportXls();
      }
    });
  }

  ngOnInit(): void {
    this.checkFluTimerCompletion();
    this.checkNavigationAway();
    this.checkLogout();
    this.checkForExcelDownload();
    this.stsFlag = this.sharedService.getSessionStorage('isStsEligible');
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userData = res;
        this.getActivityDetails();
        this.cd.detectChanges();
        this.userDataSub?.unsubscribe();
      }
    });






    this.reservationDetails = this.sharedService.getSessionStorage('fluOverviewData'); //reservation details response

    if (this.reservationDetails?.entries) {
      this.reservationDetails.entries = this.reservationDetails.entries.filter(element => element?.quantityStatus !== 'Cancelled' && !(element?.hideRow && element?.quantityStatus === 'TBD'));
      this.reservationDetails?.entries.map(entry => {
        entry.pcode = entry.product.code;
      });
      const grouped = _.groupBy(this.reservationDetails?.entries, entry => entry.pcode);
      this.reservationDetailsEntries.push(grouped);
      this.reservationDetailsProducts = Object.keys(this.reservationDetailsEntries[0]);
    }





    this.subTotal = this.reservationDetails?.entries !== undefined ? this.reservationDetails?.entries.reduce(function (acc, obj) { return acc + (obj?.basePrice?.value * obj?.quantity); }, 0) : 0;


    this.total = this.subTotal + this.reservationDetails?.totalExciseTax?.value + this.reservationDetails?.totalSalesTaxPrice?.value + this.reservationDetails?.totalOtherDiscount?.value + this.reservationDetails?.totalWebDiscount?.value;


    this.totalUnits = this.reservationDetails !== undefined ? this.reservationDetails.totalUnitCount : 0;
    this.totalDoses = this.reservationDetails !== undefined ? this.reservationDetails.totalDosesCount : 0;

    this.estimatedSavings = this.reservationDetails !== undefined ? this.reservationDetails?.totalDiscounts?.formattedValue : 0;





    this.getPaymentData();




  }

  goToProfileAccount() {
    this.routingService.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Address(s) of Business Unit(s)');
  }

  editReservation() {
    this.routingService.goByUrl('/fluCategoryPage?editReservation=yes&orderNo=' + this.reservationNo);

  }

  manageSts(event) {
    if (event === 'reservation-overview') {
      this.scheduleShipments();
    }
  }
  scheduleShipments() {
    this.tabSelectedEvent.emit('reservationSchedule')
  }

  backToDashboard() {

    this.routingService.goByUrl('influenza/dashboard?fromFlu=yes');
  }

  getActivityDetails() {

    this.influenzaService.getFluOrderActivityDetails(this.getB2BUid(), this.reservationNo);
    this.fluOrderActivityDetailsSub = this.influenzaService.fluOrderActivityDetails.subscribe(res => {
      if (res) {
        this.activityList = res?.activityList;
        this.cd.detectChanges();
        this.fluOrderActivityDetailsSub?.unsubscribe();
      }
    });
  }
  getB2BUid() {
    let b2bUid: string;
    if ('selectedLocations' in sessionStorage) {
      b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber;
    } else {

      b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0].accountNumber;
    }
    return b2bUid;
  }




























  getPaymentData() {

    this.paymentMethod = this.reservationDetails?.paymentMethod;

    if (this.paymentMethod && this.paymentMethod?.toLowerCase()?.startsWith('bill')) {
      this.deliveryDetails['paymentMethod'] = 'Bill me later';
    }
    else if (this.paymentMethod === undefined || this.paymentMethod === '') {
      if (this.reservationDetails?.paymentType?.code === 'BILL_ME_LATER') {
        this.paymentMethod = 'Bill me later';
        this.deliveryDetails['paymentMethod'] = 'Bill me later';
      }
      else {
        let cardNumber = this.reservationDetails?.paymentInfo?.cardNumber;
        let cardType = this.reservationDetails?.paymentInfo?.cardType?.code;
        if (cardType === 'EC') {
          cardType = 'Account'
        }
        if (cardType !== undefined && cardNumber !== undefined) {
          this.paymentCardDetails = `${cardType} ending in ${cardNumber?.substring(6, 10)}`;
        }
        else {
          this.paymentCardDetails = '';
        }
      }
    }
    else { //could be pay by card or pay by checking account

      let cardNumber = this.reservationDetails?.paymentInfo?.cardNumber;
      let cardType = this.reservationDetails?.paymentInfo?.cardType?.code;
      if (cardType === 'EC') {
        cardType = 'Account'
      }
      if (cardType !== undefined && cardNumber !== undefined) {
        this.paymentCardDetails = `${cardType} ending in ${cardNumber?.substring(6, 10)}`;
      }
      else {
        this.paymentCardDetails = '';
      }
    }
  }

  getReceivingHours() {
    this.deliveryDetails['receivingHours'] = this.reservationDetails?.deliveryHours;
  }

  updateDeliveryTimings(e) {
  }

  enableEdit() {
    this.isEdit = true;
    this.cd.detectChanges();
  }
  cancelEdit() {
    this.isEdit = false;
    this.cd.detectChanges();
  }




  cancelReservation() {
    this.iseditReservation = false;
    this.cd.detectChanges();
  }

  exportXls() {
    let cartProducts = [];
    this.reservationDetails?.entries.forEach(element => {

      cartProducts.push({
        'Customer': this.reservationDetails?.shipToLoc_id,
        'Material': element?.product?.code,
        'Product Name': element?.product?.variantOptions[0]?.description,
        'Contract Group': element?.contractName,
        'Units': element?.quantity,
        'Doses': element?.quantity * element?.product?.quantityPerUnit,

        'Your Price': `($ ${Math.abs((element?.basePrice?.value) * element?.quantity).toFixed(2)})`,
        'Direct Savings': `($ ${Math.abs(element?.otherDiscounts?.value).toFixed(2)})`,
        'Online Savings': `($ ${Math.abs(element?.webDiscount?.value).toFixed(2)})`,




        'Final Price': `($ ${(((element?.basePrice?.value) * element?.quantity) + element?.otherDiscounts?.value +
          element?.webDiscount?.value).toFixed(2)})`
      })
    });
    this.influenzaService.downloadXls(cartProducts, 'ReservationDetails_' + this.reservationDetails?.code);
  }

  openResContactPopover(pop) {
    pop.open();
  }

  closeResContactPopover(pop) {
    pop.close();
  }

  productDetails(productDetails) {
    productDetails['flu'] = true;
    const modalRef = this.modalService.open(ProductDetailsInfluenzaComponent, {
      windowClass: `product-details-inf-modal ${this.baseSiteId}`
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = productDetails?.code;
    modalRef.componentInstance.checkout = true;
  }













}
